import { render, staticRenderFns } from "./DistrictChecklistEdit.vue?vue&type=template&id=33667dda&scoped=true&lang=pug&"
import script from "./DistrictChecklistEdit.vue?vue&type=script&lang=ts&"
export * from "./DistrictChecklistEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DistrictChecklistEdit.vue?vue&type=style&index=0&id=33667dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33667dda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VColorPicker,VDialog,VIcon,VList,VListItem,VListItemAction,VListItemGroup,VListItemTitle,VRow})
